import styled from 'styled-components';

import Button from 'basics/buttons/Button';

import { flexColumn, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const RewardsWrap = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${COLORS.gray50};
    padding: 3.2rem;
    border-radius: 0.5rem;
    margin-bottom: 3.2rem;

    ${respondDown(Breakpoints.md)`
        background-color: ${COLORS.white};
    `}
`;
export const Rewards = styled.div`
    display: flex;
    align-items: center;
    gap: 2.4rem;
    width: 100%;

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        gap: 2rem;
    `}
`;
export const RewardsDescription = styled.div`
    display: flex;
    color: ${COLORS.textGray};
    font-size: 1.4rem;
    gap: 2.4rem;

    ${respondDown(Breakpoints.xs)`
         flex-direction: column;
    `}
`;
export const StyledButton = styled(Button)`
    margin-left: auto;

    ${respondDown(Breakpoints.md)`
        margin-left: 0;
    `}
`;

export const Logos = styled.div`
    display: flex;
    align-items: center;
`;

export const Column = styled.div`
    ${flexColumn};

    span:last-child {
        font-size: 1.6rem;
        line-height: 2.8rem;
        color: ${COLORS.textTertiary};
        display: flex;
        align-items: center;

        svg {
            margin: 0 0.5rem;
        }
    }

    ${respondDown(Breakpoints.xs)`
         text-align: center;

         span:last-child {
            justify-content: center;
         }
    `}
`;

export const Divider = styled.div`
    border-left: 0.1rem solid ${COLORS.gray100};

    ${respondDown(Breakpoints.xs)`
         display: none;
    `}
`;
